import { useEffect, useState } from 'react';

/**
 * Hold a typed value back until it stops changing.
 *
 * Filter boxes feed a React Query key, so without this every keystroke is its
 * own request: typing "phlebotomist" is twelve round trips against thousands
 * of rows, eleven of them already stale when they land. Selects and date
 * inputs need nothing of the sort — they change once per choice.
 *
 * Shared rather than copied. Two screens filter server-side the same way, and
 * a second copy of this is how one of them ends up with a different pause and
 * nobody can say which is intended.
 */
export function useDebounced<T>(value: T, ms = 300): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);
  return settled;
}
